export default __webpack_public_path__ + "static/media/producto_destacado.94f68ba3.svg";